import { MessageChatCircleIcon } from '@langchain/untitled-ui-icons';

import { useParams } from 'react-router-dom';

import { Breadcrumb, BreadcrumbData } from '../../components/Breadcrumbs';

export function ConversationCrumb(props: Partial<BreadcrumbData>) {
  const { conversationId } = useParams();
  return (
    <Breadcrumb
      icon={<MessageChatCircleIcon className="h-4 w-4" />}
      name={conversationId ?? 'Thread'}
      {...props}
    />
  );
}
